import Core from "./Core"
import Client from "./Client"
import Address from "./Address"
import Offer from "./Offer"
import Billing from "./Billing"
import Installation from "./Installation"
import List from "./List"
import POS from "./POS"
import Contract from "./Contract"
import Files from "./Files"
import AdditionalServices from "./AdditionalService"
import BiometryContract from "./BiometryContract"

const Store = {
  namespaced: true,
  modules: {
    Core,
    Client,
    Address,
    Offer,
    Billing,
    Installation,
    List,
    POS,
    Contract,
    Files,
    AdditionalServices,
    BiometryContract
  }
}

export default Store
